'use client';

import OnboardingShell from '@/components/onboarding/OnboardingShell';

export default function OnboardingLayout({ children }) {
  return <OnboardingShell>{children}</OnboardingShell>;
}
